import axios from "axios";
import oneWindowCard from "@partials/one-window-cards.handlebars";
import {ChoicesFactory} from "@main/factories/ChoicesFactory";

class OneWindowForm {
    constructor(el) {
        this.el = el;
        this.form = this.el.querySelector(".js-one-window-form");
        this.listContainer = this.el.querySelector(".js-one-window-list");
        this.visibleCards = this.listContainer.children;
        this.showMoreButton = this.el.querySelector(".js-one-window-show-more");
        this.sectionSelect = this.el.querySelector(".js-one-window-section-input");
        this.sectionChoices = ChoicesFactory.create(this.sectionSelect);

        this.serviceSelect = this.el.querySelector(".js-one-window-service-input");
        this.serviceChoices = ChoicesFactory.create(this.serviceSelect);

        this.provideCallbacks();
        this.clampCardList();
    }

    onChangeSection(event) {
        const sectionValue = event.detail.choice.value;
        axios
            .get(routes.contactsServices, {
                params: {
                    section: sectionValue,
                },
            })
            .then(({data: res}) => {
                if (res.success) {
                    this.serviceChoices.removeActiveItems();
                    this.serviceChoices.setChoices(
                        [{value: "", label: "Выберите услугу", placeholder: true}, ...res.data.services],
                        "value",
                        "label",
                        true
                    );
                    this.serviceChoices.setChoiceByValue("");
                }
            });
    }

    provideCallbacks = () => {
        this.el.addEventListener("submit", this.fetchCards);
        this.showMoreButton.addEventListener("click", this.showAllCards);
        this.sectionSelect.addEventListener("choice", this.onChangeSection.bind(this));
    };

    renderCards = (itemsPayload) => {
        this.listContainer.innerHTML = oneWindowCard(itemsPayload);
        this.visibleCards = [...this.listContainer.children];
    };

    clampCardList = () => {
        if (this.listContainer.childElementCount > 3) {
            const childrenArray = [...this.listContainer.children];
            this.visibleCards = childrenArray.slice(0, 3);
            childrenArray.slice(3).forEach((card) => card.classList.add("hidden"));
            this.setVisibleShowMoreButton(true);
        } else {
            this.setVisibleShowMoreButton(false);
        }
    };

    showAllCards = () => {
        [...this.listContainer.children]
            .slice(this.visibleCards.length)
            .forEach((card) => card.classList.remove("hidden"));
        this.setVisibleShowMoreButton(false);
    };

    setVisibleShowMoreButton = (isVisible) => {
        if (isVisible) {
            this.showMoreButton.classList.remove("hidden");
        } else {
            this.showMoreButton.classList.add("hidden");
        }
    };

    fetchCards = (e) => {
        e?.preventDefault();
        e?.stopPropagation();

        axios
            .post(this.form.action, this.formData)
            .then(({data: response}) => {
                this.renderCards({services: response.data.oneWindowItems});
                this.clampCardList();
            })
            .catch(() => {
                alert("Произошла ошибка, пропробуйте перезагрузить страницу");
            });
    };

    get formData() {
        const formData = new FormData(this.form);
        formData.delete("search_terms");
        return formData;
    }
}

document.querySelectorAll(".js-one-window").forEach((el) => new OneWindowForm(el));
